module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode())),
      expression: "(cxt.isFilterMode() && cxt.isSelectMode())"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }, [_vm._l((_vm.tagIds), function(tagId) {
    return _c('v-chip', {
      key: tagId,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.selectTag()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center",
      domProps: {
        "innerHTML": _vm._s(_vm.formatTagName(tagId))
      }
    })])
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagIds.length === 0),
      expression: "tagIds.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.selectTag()
      }
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n            Метки\n            ")])])], 2), _vm._v(" "), (_vm.cxt.isFilterMode()) ? _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.isSearching,
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "height": _vm.calcDialogScroll(48 + 48 + 52 + 2)
    },
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref, '_blank'))
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                " + _vm._s(_vm.renderHeads(item.ref)) + "\n                "), _c('br'), _vm._v("\n                ИНН: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnOrInnflHtml(item.ref.inn))
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(_vm.formats.blank(item.ref.address)))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ref.clientId),
        expression: "item.ref.clientId"
      }]
    }, [_vm._v("person")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.ref.clientId),
        expression: "!item.ref.clientId"
      }]
    }), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.ref.createDate, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c58f88e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/FavoriteSelectorTab.vue
// module id = 873
// module chunks = 1